import Http from '@/utils/httpRequest'

const axios = new Http()
export default {
    getAnnouncementList: data => {
        //公示公告-获取公示公告列表以及搜索
        return axios.post('/notice/public/list', data)

    },
    getAnnouncementDetails: data => {
        //公示公告-根据id获取公示公告详情
        return axios.get('/notice/public/getInfoById', data)
    },
}